import React, { useEffect, useState } from 'react';
import PrimaryTable from '../PrimaryTable';
import { constructTableValue } from '../../../pages/Assessment/Utils';

const Table = (props) => {
    const [tableSchema, setTableSchema] = useState([]);
    const [rowsData, setRowsData] = useState([]);

    const onRadioBoxChanged = (e, row, cell, index) => {
        let tempRows = JSON.parse(JSON.stringify(rowsData));
        row.allCells.forEach((a, i) => {
            if (i !== 0 && a.column.id !== cell.column.id) {
                tempRows[index][a.column.id] = '';
            } else {
                tempRows[index][cell.column.id] = parseInt(e.currentTarget.value);
                tempRows[index]['value'] = parseInt(e.currentTarget.value);
                let ansInternalID =
                    row?.original?.answers?.find((rowA) => rowA.answerText === cell.column.Header)?.answerInternalIdentifier || '';
                tempRows[index]['answerInternalIdentifier'] = ansInternalID;
                tempRows[index]['questionInternalIdentifier'] = row?.original?.questionInternalIdentifier;
            }
        });
        setRowsData(JSON.parse(JSON.stringify(tempRows)));
        props.changed(tempRows);
    };

    const onRadioBoxChangedForDiffQuestionOnPhq = (e, row, index) => {
        let tempRows = JSON.parse(JSON.stringify(rowsData));
        row.allCells.forEach((a, i) => {
            tempRows[index]['value'] = parseInt(e.currentTarget.value);
        });
        setRowsData(JSON.parse(JSON.stringify(tempRows)));
        props.changed(tempRows);
    };

    const handleInputchanged = (ev, row, ansItem, index) => {
        let tempRows = JSON.parse(JSON.stringify(rowsData));
        tempRows[index]['textAns'] = [
            {
                answerInternalId: ansItem?.answerInternalIdentifier,
                answer: ev.toString(),
                ansId: ansItem?.answerId
            }
        ];
        setRowsData(JSON.parse(JSON.stringify(tempRows)));
        props.changed(tempRows);
    };

    const blurrr = () => {
        props.handleOnBlur();
    };

    useEffect(() => {
        let tSchema = [];
        if (props.data?.questions?.length > 0) {
            tSchema.push({
                Header: props.data?.questions[0].questionText,
                accessor: 'questionText',
                sortable: false
            });
        }
        if (props.data?.questions?.length > 0 && props.data?.questions[0].answers?.length > 0) {
            let accessorObj = {};
            props.data?.questions[0].answers.forEach((element) => {
                let ansAccessor = element.answerText.replace(' ', '_');
                tSchema.push({
                    Header: element.answerText,
                    accessor: ansAccessor,
                    sortable: false,
                    width: props?.questionLevelAssessment && element.answerText === 'I choose not to answer this question' ? '30%' : '10%',
                    // thClass: 'text-overflow',
                    customCell: props.data?.questions[0].answerControlType,
                    fieldType: props.data?.questions[0].answerControlType === 106 ? 'radio' : 'checkbox',
                    customTypeValue: 'answerId',
                    customTypeKey: 'questionId',
                    answerId: element.answerId
                });

                accessorObj = { ...accessorObj, [ansAccessor]: '' };
            });
            let rowsList = JSON.parse(JSON.stringify(props.data?.questions));
            let afterRemovingHeader = rowsList.slice(1);

            let finalArr = afterRemovingHeader.map((ques) => {
                let b = { ...ques, ...accessorObj };
                if (ques.value) {
                    let matchedAns = props.data?.questions[0].answers.find((ans) => ans.answerId === parseInt(ques.value));
                    let matchID = matchedAns?.answerText.replace(' ', '_');
                    if (matchID) b[matchID] = ques.value;
                }
                return b;
            });
            setRowsData(finalArr);
            props.changed(finalArr);
        }
        setTableSchema([...tSchema]);
        props.setUpdatedArr && props.setUpdatedArr(true);
        props.setUpdateTable && props.setUpdateTable(false);
    }, [props.updateTable]);

    return (
        <div className={`me-3 ${props.disable ? 'pe-none bg-gray200' : ''}`}>
            <PrimaryTable
                tabelID={props?.type}
                columns={tableSchema}
                data={rowsData}
                customPageSize={props.data?.questions?.length}
                divClass="table-responsive table-card"
                tableClass="table table-borderless table-centered align-middle"
                theadClass="default-table-header text-muted"
                hideCardTitle={true}
                changed={onRadioBoxChanged}
                onBlur={blurrr}
                fromPage="dynamicForms"
                onRadioBoxChangedForDiffQuestionOnPhq={onRadioBoxChangedForDiffQuestionOnPhq}
                handleInputchanged={handleInputchanged}
                constructTableValue={constructTableValue}
                answerLevelRulesObj={props?.answerLevelRulesObj}
                memberLevelRule={props?.memberLevelRule}
                disableField={props?.disable}
            />
        </div>
    );
};

export default Table;
